import {fetchHandler,fetchCatcher} from '@/js/sageflo/ui-helpers.js'
//State pertaining to the current user
//Don't put users for admin purposes in this file
export default {
  namespaced: false,
  state: {
    privs: {},
    uiConfig: {},
    user: {},
    userInfo: {},
    allowSubscriberLookup: false,
    showEmailEvents: false,
    showSmsEvents: false,
    authToken: null,
    features: {},
  },
  getters: {},
  actions: {
    async fetchUiConfig({state,commit,dispatch}){
      return fetch('/api/v1/ui-config',{credentials:'include'})
        .then(fetchHandler(dispatch))
        .then(async response=>{
          let result = await response.json();
          commit("setUiConfig",result);
          console.log("response headers.authorization:",response.headers.get("authorization"))
          commit("setAuthToken",response.headers.get("authorization"))
          dispatch("initTracking",result);
        })
        .catch(fetchCatcher(dispatch))
    },
    async fetchUserInfo({state,commit,dispatch}){
      return fetch('/api/v2/profile',{credentials:'include'})
        .then(fetchHandler(dispatch))
        .then(async response=>{
          let result = await response.json();
          commit("setUserInfo",result);
        })
        .catch(fetchCatcher(dispatch))
    },
    async updateUserInfo({state,commit,dispatch,rootState},attrs){
      return fetch(`/api/v1/accounts/${attrs.account_id}/users/${attrs.id}`,{
          method: 'POST',
          headers: {'Content-Type': 'application/json; charset=utf-8'},
          body: JSON.stringify(attrs),
          credentials:'include',
        })
        .then(fetchHandler(dispatch,{showAlert:true}))
        .then(async response=>{
          if (response.ok){
            let result = await response.json();
            delete attrs.password
            delete attrs.password_confirm
            commit("updateUserInfo",attrs)
          }
        })
        .catch(fetchCatcher(dispatch))
    },
  },
  mutations: {
    setAuthToken(state,token){
      state.authToken = token;
    },
    setUiConfig(state,config){
      state.uiConfig = config;
      state.privs = config.privs;
      state.features = config.account.features;
      for (let subAccount of config.sub_accounts){
        if (subAccount.can_profile_lookup) {
          state.allowSubscriberLookup = true;
        }
        if (subAccount.process_email_events){
          state.showEmailEvents = true;
        }
        if (subAccount.process_sms_events){
          state.showSmsEvents = true;
        }
      }
    },
    setUserInfo(state,userInfo){
      state.userInfo = userInfo;
    },
    updateUserInfo(state,attrs){
      Object.assign(state.userInfo,attrs)
    },
  },  
}